module.exports = __webpack_public_path__ + "static/media/marlene-flash.f9a8c461.png";